export default __webpack_public_path__ + "static/media/GiftExchange.b092b20b.png";